import React, {useState} from 'react';
import {useAlerts} from '../ui/alert';
import {getDateOrEmpty} from '../utils/utils';
import {log} from '../utils/logs';
import {ProduccionFiltroView} from './ProduccionFiltroView';

const queryString = require('query-string');

export const ProduccionFiltro = ({history, token}) => {
  const [usuarioOption, setUsuarioOption] = useState(null);
  const [equipoOption, setEquipoOption] = useState(null);

  const [showUsuarios, setShowUsuarios] = useState(true);
  const [showEquipos, setShowEquipos] = useState(false);
  const [showSinFiltro, setShowSinFiltro] = useState(false);

  const dateForInicio = new Date();

  const [inicio, setInicio] = useState(dateForInicio);

  const dateForFin = new Date();

  const [fin, setFin] = useState(dateForFin);

  const {setTopAlert, topAlert} = useAlerts();

  const getTipo = () => {
    if (showUsuarios) {
      return 'selectorYSupervisor';
    } else if (showEquipos) {
      return 'equipo';
    } else {
      return 'general';
    }
  };

  const submit = () => {
    const params = {
      selectorId: usuarioOption?.value,
      equipoId: equipoOption?.value,
      fechaInicio: getDateOrEmpty(inicio),
      fechaFin: getDateOrEmpty(fin),
      tipo: getTipo(),
    };

    log({'submit.params': params});

    const newUrl = `/produccion/selector/?${queryString.stringify(params)}`;

    history.push(newUrl);
  };

  return (
    <ProduccionFiltroView
      token={token}
      history={history}
      topAlert={topAlert}
      usuarioOption={usuarioOption}
      setUsuarioOption={setUsuarioOption}
      equipoOption={equipoOption}
      setEquipoOption={setEquipoOption}
      inicio={inicio}
      setInicio={setInicio}
      fin={fin}
      setFin={setFin}
      submit={submit}
      setTopAlert={setTopAlert}
      showUsuarios={showUsuarios}
      setShowUsuarios={setShowUsuarios}
      showEquipos={showEquipos}
      setShowEquipos={setShowEquipos}
      showSinFiltro={showSinFiltro}
      setShowSinFiltro={setShowSinFiltro}
    />
  );
};
